import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import Portal from '@atlaskit/portal';
import { layers } from '@atlaskit/theme/constants';
var _React$createContext = /*#__PURE__*/React.createContext(undefined),
  Provider = _React$createContext.Provider,
  Consumer = _React$createContext.Consumer;
export var PortalProvider = function PortalProvider(_ref) {
  var children = _ref.children;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    portal = _useState2[0],
    setPortal = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isPortalReady = _useState4[0],
    setIsPortalReady = _useState4[1];
  useEffect(function () {
    if (portal !== null) {
      setIsPortalReady(true);
    }
  }, [portal]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, isPortalReady && /*#__PURE__*/React.createElement(Provider, {
    value: portal
  }, children), /*#__PURE__*/React.createElement(Portal, {
    zIndex: layers.modal() + 1
  }, /*#__PURE__*/React.createElement("div", {
    "data-testid": "forge-ui-portal",
    ref: setPortal
  })));
};
export { Consumer as PortalConsumer };